import { EventRegistry } from '../../../../../domain/event/event.registry';
import { ReferenceTableEvent } from './reference-table.event';
export class ReferenceTableInitializedEvent extends ReferenceTableEvent {
    constructor(payload, metadata, fromPersistence) {
        super({
            subject: `reference-table/${payload.id}`,
            type: ReferenceTableInitializedEvent.type,
            payload,
            metadata,
            fromPersistence,
        });
    }
}
ReferenceTableInitializedEvent.subject = 'reference-table/aggregate/reference-table/ReferenceTableInitializedEvent';
ReferenceTableInitializedEvent.type = 'com.treeplotter.api.reference-table.initialized.v1';
EventRegistry.register(ReferenceTableInitializedEvent.type, ReferenceTableInitializedEvent);
//# sourceMappingURL=reference-table-initialized.event.js.map